import { FaCar } from "react-icons/fa";
import images from "./images";

const About = {
    sub: "About Us",
    heading: "Your Trusted Partner for Car Rentals",
    description: "Welcome to DriveOn, your go-to destination for premium car rental services. Whether you need a car for business or travel, we offer a wide selection of vehicles at competitive rates. Enjoy a seamless rental experience with our flexible plans.",
    points: [
        "Easy Online Booking",
        "Wide Range of Vehicles",
        "Flexible Rental Plans",
        "24/7 Customer Support",
        "Affordable Pricing",
        "Well-Maintained Cars",
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        alt1: "About-Image-1",
        alt2: "About-Image-2",
        alt3: "About-Image-3",
        experience: {
            years: "Since 2017",
            title: "Car Rental",
            icon: <FaCar />
        }
    },
    button: {
        text: "Rent a Car",
        link: "Car-Booking"
    }
};

export default About;